import { BaseService } from "./base.service";
import { IJobTitle } from "models/JobTitleModel";

class JobTitleServiceInternal extends BaseService {
	getJobTitleList = async (): Promise<IJobTitle[]> =>
		this.callApi<IJobTitle[]>(
			`JobTitle/GetJobTitleList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const JobTitleService = new JobTitleServiceInternal();
